class ProductGalleryController extends window.StimulusController {
  static targets = ["swiperWrapper"];

  connect() {
    this.swiperThumb = this.initThumbSwiper();

    this.initMainSwiper();
  }

  initMainSwiper() {
    let thumbs = {};

    if (this.swiperWrapperTarget.children.length > 1) {
      thumbs = {
        swiper: this.swiperThumb,
        slideThumbActiveClass: "tw-swiper-slide-thumb-active",
      };
    }

    return new Swiper(".swiper-container", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      slidesPerView: 1,
      thumbs,
    });
  }

  initThumbSwiper() {
    return new Swiper(".swiper-thumb", {
      spaceBetween: 10,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
    });
  }
}
Stimulus.register("productGallery", ProductGalleryController);
